import AddDealership from './AddDealership';

export default AddDealership;
